"use client";

import { Route as UnknownRoute } from "@faire/web--source/ui/routing/Route";
import React from "react";

// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { LoggedInCategoryPageBase } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/LoggedInCategoryPageBase";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { SDUICategoryPageBase } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/SDUICategoryPageBase";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { LoggedInCategoryPageBaseProvider } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/LazyLoggedInCategoryPageBase";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { SDUICategoryPageBaseProvider } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/LazySDUICategoryPageBase";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { LoggedOutCategoryPage } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/LoggedOutCategoryPage";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { LoggedOutCategoryPageProvider } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/LazyLoggedOutCategoryPage";
import { CategoryRouter } from "@faire/retailer/views/category/CategoryRouter";

export const EagerlyRenderCategoryRoutes = () => {
  return (
    <UnknownRoute
      path="/category"
      component={CategoryRouterWithEagerlyLoadedRenderers}
    />
  );
};

const CategoryRouterWithEagerlyLoadedRenderers = () => {
  return (
    <LoggedOutCategoryPageProvider value={LoggedOutCategoryPage}>
      <SDUICategoryPageBaseProvider value={SDUICategoryPageBase}>
        <LoggedInCategoryPageBaseProvider value={LoggedInCategoryPageBase}>
          <CategoryRouter />
        </LoggedInCategoryPageBaseProvider>
      </SDUICategoryPageBaseProvider>
    </LoggedOutCategoryPageProvider>
  );
};
